import Cookie from "js-cookie";
import Client from './Client';
import ToastService from '@/services/ToastService'

export default new class {

    constructor() {
        this.clientCredentials = {
            client_id: process.env.VUE_APP_CLIENT_ID,
            client_secret: process.env.VUE_APP_CLIENT_SECRET
        };
    }

    async authenticate(credentials) {
        const data = {
            grant_type: 'password',
            username: credentials.username,
            password: credentials.password,
            ...this.clientCredentials
        };

        const url = '/api/authentication/token';
        const response = await Client.post(url, data);
        this.persistTokens(response);

        // NOTE: call PHP script here to set cookie on Intersect
    }

    async refreshToken() {
        try {
            const data = {
                grant_type: 'refresh_token',
                refresh_token: Cookie.get('_hp_refresh'),
                ...this.clientCredentials
            }

            const url = '/api/authentication/token';
            const response = await Client.post(url, data);
            this.persistTokens(response);

            return response;
        } catch (error) {
            this.flushTokens();
        }
    }

    async changePassword(credentials) {
        const data = {
            old_password: credentials.password,
            new_password: credentials.newPassword,
            confirm_password: credentials.confirmPassword,
            ...this.clientCredentials
        };

        const url = '/api/me/password';
        const response = await Client.post(url, data);
        return response;
    }

    persistTokens(authResponse) {
        Cookie.set('_hp_access', authResponse.access_token, { expires: 1 });
        Cookie.set('_hp_refresh', authResponse.refresh_token, { expires: 7 });
    }

    flushTokens() {
        Cookie.remove('_hp_access');
        Cookie.remove('_hp_refresh');
    }

    async getUser() {
        const response = await Client.get(`/api/me`);
        return response.data;
    }

    async isLoggedIn() {
        try {
            if (Client.hasTokens()) {
                return await this.getUser();
            } else {
                if (Cookie.get('_hp_refresh') == undefined) {
                    return false;
                }
                return await this.refreshToken();
            }
        } catch (error) {
            if(error.response.status === 401) {
                return await this.refreshToken();
            } else {
                this.flushTokens();
            }
        }
    }

    async logout() {
        return Client.post('/api/logout')
    }

    async signOutGoogle() {
        const gapi = window.gapi;

        var auth2 = gapi.auth2.getAuthInstance();
            auth2.signOut().then(function () {
            console.log('User signed out.');
        });
        auth2.disconnect();
    }


    async loginByGoogle(token) {
        const data = {
            grant_type: 'google_web',
            provider: 'google',
            ...this.clientCredentials,
            token
        };

        const url = '/api/authentication/token';

        const response = await Client.post(url, data).catch(error => {
            console.info(error);
            ToastService.error("Invalid user credentials.")
            this.flushTokens();
            this.signOutGoogle();
        });

        this.persistTokens(response);
    }
}
